module.exports = __webpack_public_path__ + "img/facial_hair_chin_mustache_thick_average.809e167e.png";